<ng-container *ngIf="initialized && objectLoaded && dto && objectIdentifier">
    @if (uiMode == 'inline') {
        <eu-registration-inline
                [objectIdentifier]="objectIdentifier"
                [importObjectContext]="importObjectContext"
        ></eu-registration-inline>
    } @else {
        <mvs-widget [widgetData]="widgetRegistration" *ngIf="widgetRegistration"></mvs-widget>
    }
</ng-container>
